module.exports = __webpack_public_path__ + "img/image.2689fb54.svg";